/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Resource = require('./Resource');

module.exports = _Resource.Resource;


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/bootstrap.js
// module id = 431
// module chunks = 0